<div class="splash">
    <div class="row align-items-center">
        <div class="col-sm-5 col-md-4 offset-md-2 col-lg-3 offset-lg-2">

            <div class="row">
                <div class="col">
                    <img src="images/deloitte.svg" alt="Deloitte" class="splash__logo mb-3" />
                </div>
            </div>

            <div class="row mb-5 pt-4">
                <div class="col">
                    <p class="splash__title">
                        Password Reset
                    </p>
                    <p class="text-muted textBody--md mt-0 mb-4">Enter email below to reset password</p>
                    <form class="form" [formGroup]="resetPasswordFormGroup" (ngSubmit)="resetPasswordClicked(resetPasswordFormGroup.value, resetPasswordFormGroup.valid)" novalidate>
                        <div class="form-group">
                            <label class="text-white" for="email">Email Address</label>
                            <input placeholder="Enter your email address" class="form-control" name="email" type="text" formControlName="email" autocomplete="off" />
                            @if (resetPasswordFormGroup.controls['email'].hasError('required') && resetPasswordFormGroup.controls['email'].touched) {
                            <div class="alert alert-danger mt-3">You must include an email.</div>
                            }
                            @if (resetPasswordFormGroup.controls['email'].hasError('pattern') && resetPasswordFormGroup.controls['email'].touched) {
                            <div class="alert alert-danger mt-3">Email is invalid.</div>
                            }
                        </div>

                        <div class="form-group mt-4">
                            <button class="btn btn-info btn-block" type="submit" [disabled]="!resetPasswordFormGroup.valid && !resettingPassword">
                                {{resettingPassword ? "Resetting password..." : "Reset password"}}
                                <i class="fa fa-sign-in"></i>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row pt-5">
                <div class="col">
                    <small> Need assistance? | <a href="mailto:{{ businessFunction?.email }}?subject={{ businessFunction?.displayName }} - Login Enquiry">Contact us</a></small>
                </div>
            </div>
        </div>

        <div class="col-sm-7 col-md-6">
            <div class="splash__image">
                <img src="/images/globe.jpg" />
            </div>
        </div>
    </div>
</div>